import ProductRow from "@/components/ProductRow";
import { subLabel } from "@/lib/i18n";

export default function ProductGroup({ sub, products, lang }) {
  return (
    <section
      data-testid={sub ? `subcategory-${sub.toLowerCase().replace(/\s+/g, "-")}` : "subcategory-main"}
      className="mt-5"
    >
      {sub && (
        <h2 className="font-cinzel text-sm tracking-[0.25em] uppercase text-[var(--bordeaux-2)] mb-1 flex items-center gap-3">
          {subLabel(sub, lang)}
          <span className="flex-1 h-px bg-[#C5A059]/40" aria-hidden="true" />
        </h2>
      )}
      <div className="bg-[var(--card)] border border-[var(--line)] rounded-lg px-4 shadow-sm">
        {products.map((prod) => (
          <ProductRow key={prod.id} product={prod} />
        ))}
      </div>
    </section>
  );
}
